export default __webpack_public_path__ + "static/media/panton-bold-webfont.3c02074b.woff2";